import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './main.routes';

// https://github.com/cschwarz/wkx Parsing WKT to GeoJson
// https://github.com/mapbox/polyline/blob/master/API.md  Encoding or Decoding Geojson to google encoded format

export class MainController {
    $http;

    awesomeThings = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope) {
        this.$http = $http;
        this.$scope = $scope;
        //Set global variables
        $scope.info = {};
        $scope.infoBoxHeaderColor = '';

        $scope.popupBox = document.getElementById('popupBox');
        $scope.infoBox = document.getElementById('infoBox');
        $scope.popupBoxHeader = document.getElementById('popupBox-header');
        $scope.popupBoxHeader.style.backgroundColor = 'green';
        $scope.showUrl = false;


        //Get spatial data from Socrata
        $scope.getLineLayer = function() {
            $scope.baelLineLayer = new google.maps.Data();
            $http.get("https://data.bayareametro.gov/resource/t7di-4itt.geojson")
                .then(function(data) {
                    $scope.geoJson = data.data;
                    var geoJsonObject = $scope.geoJson;

                    $scope.baelLineLayer.addGeoJson(geoJsonObject);


                    $scope.baelLineLayer.setStyle(function(feature) {
                        var lineAttr = feature.getProperty('status');
                        var color, strokeWeight;
                        // console.log(lineAttr);
                        if (lineAttr === 'Open') {
                            color = '#00B12A';
                            strokeWeight = 5;
                        } else if (lineAttr === 'Future') {
                            color = '#BC1CF1';
                            strokeWeight = 5;
                        } else if (lineAttr === 'Under Construction') {
                            color = '#EC7B02';
                            strokeWeight = 5;
                        } else if (lineAttr === 'Under Review/Design') {
                            color = '#009CFF';
                            strokeWeight = 5;
                        }

                        return {
                            color: 'white',
                            strokeColor: color,
                            strokeWeight: strokeWeight
                        }
                    });


                });
            return $scope.baelLineLayer;
        }

        $scope.layer = $scope.getLineLayer();
        $scope.infowindow = new google.maps.InfoWindow;

        $scope.layer.addListener('mouseover', function(event) {
            console.log(event);
            $scope.feature = event.feature;
            var x = event.ya.clientX + 10; //we clicked here
            var y = event.ya.clientY - 30;
            console.log($scope.feature.getProperty('status'), ': is the status');

            $scope.popupBox.style.left = x + 'px';
            $scope.popupBox.style.top = y + 'px';

            if ($scope.feature.getProperty('status') === 'Open') {
                $scope.popupBoxHeaderColor = '#00B12A';

            } else if ($scope.feature.getProperty('status') === 'Future') {
                $scope.popupBoxHeaderColor = '#BC1CF1';

            } else if ($scope.feature.getProperty('status') === 'Under Construction') {
                console.log('check');
                $scope.popupBoxHeaderColor = '#EC7B02';

            } else if ($scope.feature.getProperty('status') === 'Under Review/Design') {
                $scope.popupBoxHeaderColor = '#009CFF';

            }

            //Update line style
            $scope.baelLineLayer.setStyle(function(item) {
                var lineStatus = item.getProperty('status');
                var lineID = item.getProperty('uuid');

                var color, strokeWeight;
                // console.log(lineAttr);
                if (lineStatus === 'Open') {
                    color = '#00B12A';
                    // strokeWeight = 5;
                } else if (lineStatus === 'Future') {
                    color = '#BC1CF1';
                    // strokeWeight = 5;
                } else if (lineStatus === 'Under Construction') {
                    color = '#EC7B02';
                    // strokeWeight = 5;
                } else if (lineStatus === 'Under Review/Design') {
                    color = '#009CFF';
                    // strokeWeight = 5;
                }

                if (lineID === $scope.feature.uuid) {
                    strokeWeight = 8;
                } else {
                    strokeWeight = 5;
                }

                return {
                    color: 'white',
                    strokeColor: color,
                    strokeWeight: strokeWeight
                }
            });

            $scope.popupBoxHeader.style.backgroundColor = $scope.popupBoxHeaderColor;
            $scope.popupBox.style.display = 'block';

            console.log($scope.feature, " : is the feature");
            $('#popup-title').html($scope.feature.getProperty('freeway') + ': ' + $scope.feature.getProperty('startend'));
            $('#popup-freeway').html($scope.feature.getProperty('freeway'));
            $('#popup-open').html($scope.feature.getProperty('open'));
            $('#popup-laneinfo').html($scope.feature.getProperty('laneinfo'));
            $('#popup-description').html($scope.feature.getProperty('description'));
            $('#popup-lanemiles').html($scope.feature.getProperty('lanemiles'));
            $('#popup-operator').html($scope.feature.getProperty('operator'));



        });

        $scope.layer.addListener('mouseout', function(event) {
            //Hide popup box
            popupBox.style.display = 'none';

            //Reset line style
            $scope.baelLineLayer.setStyle(function(feature) {
                var lineAttr = feature.getProperty('status');
                var color, strokeWeight;
                // console.log(lineAttr);
                if (lineAttr === 'Open') {
                    color = '#00B12A';
                    strokeWeight = 5;
                } else if (lineAttr === 'Future') {
                    color = '#BC1CF1';
                    strokeWeight = 5;
                } else if (lineAttr === 'Under Construction') {
                    color = '#EC7B02';
                    strokeWeight = 5;
                } else if (lineAttr === 'Under Review/Design') {
                    color = '#009CFF';
                    strokeWeight = 5;
                }

                return {
                    color: 'white',
                    strokeColor: color,
                    strokeWeight: strokeWeight
                }
            });

        });


        $scope.layer.addListener('click', function(event) {
            console.log("clicked on map ", event);
            // $scope.info = event.feature.l;
            $scope.feature = event.feature;
            $scope.info = {};
            $scope.closeInfoBox();


            //Set styles
            $scope.updateStyles($scope.feature);

            console.log($scope.feature.freeway);
            $scope.info = {};
            $scope.zoomToFeature($scope.feature);
        });

        $scope.updateStyles = function(feature) {
            console.log(feature, ' : updating the styles');

            if (feature.status === 'Open') {
                $scope.infoBoxHeaderColor = '#00B12A';

            } else if (feature.status === 'Future') {
                $scope.infoBoxHeaderColor = '#BC1CF1';

            } else if (feature.status === 'Under Construction') {
                console.log('check');
                $scope.infoBoxHeaderColor = '#EC7B02';

            } else if (feature.status === 'Under Review/Design') {
                $scope.infoBoxHeaderColor = '#009CFF';

            }

            // $scope.infoBoxHeader.style.backgroundColor = $scope.infoBoxHeaderColor;
            $('.test-header').css('background-color', $scope.infoBoxHeaderColor);
            // $scope.popupBox.style.display = 'block';
            $('#infoBox-header').html(feature.freeway + ': ' + feature.startend);
            $('#infoBox-freeway').html(feature.freeway);
            $('#infoBox-open').html(feature.open);
            $('#infoBox-laneinfo').html(feature.laneinfo);
            $('#infoBox-description').html(feature.description);
            $('#infoBox-direction').html(feature.direction);
            $('#infoBox-lanemiles').html(feature.lanemiles);
            $('#infoBox-operator').html(feature.operator);

            $scope.infoBox.style.display = 'block';
        }

        $scope.closeInfoBox = function() {
            console.log('closed');
            $scope.info = {};
            $scope.infoBox.style.display = 'none';
        }

        $scope.openInfoBox = function(feature) {
            // $scope.feature = feature;
            $scope.info = feature;

            console.log($scope.baelLineLayer);
            if ($scope.info.url) {
                $scope.showUrl = true;
            } else {
                $scope.showUrl = false;
            }
            $scope.infoBoxHeaderColor = $scope.info.color;

            $('.test-header').css('background-color', $scope.infoBoxHeaderColor);
            // $scope.popupBox.style.display = 'block';
            // $('#infoBox-header').html(feature.freeway);
            // $('#infoBox-freeway').html(feature.freeway);
            // $('#infoBox-open').html(feature.open);
            // $('#infoBox-laneinfo').html(feature.laneinfo);
            // $('#infoBox-description').html(feature.description);
            // $('#infoBox-lanemiles').html(feature.lanemiles);
            // $('#infoBox-operator').html(feature.operator);

            $scope.infoBox.style.display = 'block';

            $scope.zoomToFeature(feature);
        }



        $scope.zoomToFeature = function(feature) {
            console.log('clicked');
            var zoomFeature;
            console.log(feature);
            console.log($scope.map);
            // console.log(feature);
            console.log($scope.info);
            // $scope.feature = feature;
            console.log($scope.info, ": the info check");
            if ('uuid' in $scope.info) {
                $scope.feature = $scope.info;
            } else {
                console.log('its not the info!!!');
                $scope.feature = {};
                $scope.feature.uuid = feature.getProperty('uuid');
                $scope.feature.freeway = feature.getProperty('freeway');
                $scope.feature.startend = feature.getProperty('startend');
                $scope.feature.status = feature.getProperty('status');
                $scope.feature.open = feature.getProperty('open');
                $scope.feature.laneinfo = feature.getProperty('laneinfo');
                $scope.feature.description = feature.getProperty('description');
                $scope.feature.direction = feature.getProperty('direction');
                $scope.feature.lanemiles = feature.getProperty('lanemiles');
                $scope.feature.operator = feature.getProperty('operator');
                $scope.feature.url = feature.getProperty('url');
                console.log("not the info feature: ", $scope.feature);

            }
            console.log($scope.feature.status);
            console.log($scope.feature.url);

            if ($scope.feature.url) {
                $scope.showUrl = true;
            } else {
                console.log('its false');
                $scope.showUrl = false;
            }
            // $scope.info.uuid = 2;

            //Set styles
            $scope.updateStyles($scope.feature);


            console.log($scope.info);

            var bounds = new google.maps.LatLngBounds();

            $scope.baelLineLayer.forEach(function(feature) {
                // console.log(feature.getProperty('uuid'));
                // console.log($scope.feature);
                // console.log(feature.getGeometry());
                if (feature.getProperty('uuid') === $scope.feature.uuid) {
                    console.log('MATCH');
                    processPoints(feature.getGeometry(), bounds.extend, bounds);
                    $scope.map.setCenter(bounds.getCenter());
                    $scope.map.fitBounds(bounds);
                    // $scope.openInfoBox($scope.info);
                    // $scope.popupBox.style.display = 'block';
                }
            })

            function processPoints(geometry, callback, thisArg) {
                if (geometry instanceof google.maps.LatLng) {
                    callback.call(thisArg, geometry);
                } else if (geometry instanceof google.maps.Data.Point) {
                    callback.call(thisArg, geometry.get());
                } else {
                    geometry.getArray().forEach(function(g) {
                        processPoints(g, callback, thisArg);
                    });
                }
            }
        }

        $http.get('https://data.bayareametro.gov/resource/t7di-4itt.json?$select=active,description,direction,freeway,operator,startend,uuid,status,open,lanemiles,url')
            .then(response => {
                console.log(response.data);
                $scope.mapList = response.data;
                $scope.mapList.forEach(function(item) {
                    if (item.status === 'Open') {
                        item.color = '#00B12A';
                        item.liColor = '#E0F1E4';
                    } else if (item.status === 'Future') {
                        item.color = '#BC1CF1';
                        item.liColor = '#EED3F7';
                    } else if (item.status === 'Under Construction') {
                        item.color = '#EC7B02';
                        item.liColor = '#F6E6E5';
                    } else if (item.status === 'Under Review/Design') {
                        item.color = '#009CFF';
                        item.liColor = '#DDE9F2';
                    }
                })
            })
            .catch(err => {
                console.log(err);
            });

        $scope.initMap = function() {
            $scope.map = new google.maps.Map(document.getElementById('map'), {
                center: { lat: 37.796966, lng: -122.275051 },
                zoom: 10,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.TOP_RIGHT
                },
                mapTypeControl: true,
                mapTypeControlOptions: {
                    style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                    position: google.maps.ControlPosition.TOP_RIGHT
                },
                scaleControl: true,
                streetViewControl: false,
                rotateControl: true,
                fullscreenControl: true
            });

            // var layer = getLineLayer();
            $scope.layer.setMap($scope.map);


        }

        $scope.initMap();

    }

    $onInit() {

        var map, baelLineLayer;
        var http = this.$http;
        var scope = this.$scope;

        /**
         * Process each point in a Geometry, regardless of how deep the points may lie.
         * @param {google.maps.Data.Geometry} geometry The structure to process
         * @param {function(google.maps.LatLng)} callback A function to call on each
         *     LatLng point encountered (e.g. Array.push)
         * @param {Object} thisArg The value of 'this' as provided to 'callback' (e.g.
         *     myArray)
         */
        function processPoints(geometry, callback, thisArg) {
            if (geometry instanceof google.maps.LatLng) {
                callback.call(thisArg, geometry);
            } else if (geometry instanceof google.maps.Data.Point) {
                callback.call(thisArg, geometry.get());
            } else {
                geometry.getArray().forEach(function(g) {
                    processPoints(g, callback, thisArg);
                });
            }
        }




        //Set Layer Infowindows


        //End Infowindows



        function test() {
            var bounds = new google.maps.LatLngBounds();
            map.data.forEach(function(feature) {
                console.log(feature.getGeometry);
                console.log(feature.l.OBJECTID);
                if (feature.l.OBJECTID = 1584) {
                    processPoints(feature.getGeometry(), bounds.extend, bounds);
                }

            });
            // processPoints(baelLineLayer.getFeatureById(2).getGeometry(),
            //     bounds.extend,
            //     bounds);

            // map.fitBounds(bounds);
        }


    }

    addThing() {
        if (this.newThing) {
            this.$http.post('/api/things', {
                name: this.newThing
            });
            this.newThing = '';
        }
    }

    deleteThing(thing) {
        this.$http.delete(`/api/things/${thing._id}`);
    }
}

export default angular.module('baelApp.main', [uiRouter])
    .config(routing)
    .component('main', {
        template: require('./main.html'),
        controller: MainController
    })
    .name;


// WEBPACK FOOTER //
// ./client/app/main/main.component.js